/** Clés de cache TanStack Query de l'espace garage (une seule source pour invalider). */
export const keys = {
  home: ['home'] as const,
  interventions: (scope: 'present' | 'all') => ['interventions', scope] as const,
  interventionsAll: ['interventions'] as const,
  /** Recherche de dossiers, clôturés compris (sous `interventions` : invalidée avec les listes). */
  dossiers: (q: string) => ['interventions', 'all', 'search', q] as const,
  intervention: (id: string) => ['intervention', id] as const,
  media: (id: string) => ['media', id] as const,
  complements: (id: string) => ['complements', id] as const,
  messages: (id: string) => ['messages', id] as const,
  workItems: (id: string) => ['workItems', id] as const,
  activity: (id: string) => ['activity', id] as const,
  deliveries: (id: string) => ['deliveries', id] as const,
  vehicle: (id: string) => ['vehicle', id] as const,
  // ─── Base garage (02/10/2026) ───
  customer: (id: string) => ['customer', id] as const,
  customerVehicles: (id: string) => ['vehicles', 'customer', id] as const,
  /** Annuaire (`directory.search`) : filtre et recherche. */
  base: (kind: string, q: string) => ['base', kind, q] as const,
  baseAll: ['base'] as const,
  customers: (q: string) => ['customers', q] as const,
  vehicles: (q: string) => ['vehicles', q] as const,
  team: ['team'] as const,
  directory: ['team.directory'] as const,
  branding: ['branding'] as const,
  settings: ['settings'] as const,
  /** 08/10/2026 : catalogue de prestations (`catalog.list`). */
  catalog: ['catalog'] as const,
  locations: ['locations'] as const,
  // ─── Vague 5 ───
  unread: ['inbox', 'unread'] as const,
  inbox: (filters: string) => ['inbox', 'list', filters] as const,
  inboxAll: ['inbox'] as const,
  support: ['support'] as const,
  supportActivity: (id: string) => ['support', 'activity', id] as const,
  // ─── Vague 6 ───
  entryReport: (interventionId: string) => ['entryReport', interventionId] as const,
  planned: ['planned'] as const,
  plannedOne: (id: string) => ['planned', id] as const,
  // ─── Vague 7 (expérience) ───
  homeLayout: ['home', 'layout'] as const,
  /** Liste du parc triée par priorité (sous `interventions` : invalidée avec les listes). */
  priority: ['interventions', 'present', 'priority'] as const,
  metrics: (month: string) => ['metrics', 'atelier', month] as const,
  /** 03/10/2026 : espace « Gestion » (historique filtré, activité d'une période). */
  managementHistory: (query: object) => ['management', 'history', query] as const,
  managementActivity: (period: string, key: string | null) => ['management', 'activity', period, key] as const,
  agenda: (from: string, to: string, view: string) => ['agenda', from, to, view] as const,
  portalPreview: (interventionId: string) => ['intervention', interventionId, 'portal-preview'] as const,
  lastEmail: (interventionId: string) => ['intervention', interventionId, 'last-email'] as const,
};
